import { Component,OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PdaGeneralDataModel } from 'src/app/pda/models/sections/general-data';
import { pdaConfiguration } from 'src/app/pda/utils/pda-configuration';
import { GeneraldataServiceTsService } from './Service/generaldata.service.ts.service';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';
import { Subscription, catchError, map, mergeMap, of } from 'rxjs';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { AppData } from 'src/app/data-store';
import { PdaDataStore } from 'src/app/pda/store/pda-store';
import { PctInfoFascicolo } from 'src/app/pda/models/sections/pct-info-fascicolo';
import { PdaFascicolopctEditComponent } from '../../pda-fascicolopct-edit/pda-fascicolopct-edit.component';
import { PdaAccessToken, PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { mockGeneralDataValue } from 'src/app/pda/utils/mock/general-data-mock-value';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { FascicoloPCT } from 'src/app/common/models/mock/fascicoloPCT';
import { CreazionePraticaService } from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica.service';
import { pdaRegistryConst } from 'src/app/pda/pages/consultazione/constants/registry-const';

@Component({
  selector: 'app-pda-section-general-data',
  templateUrl: './pda-section-general-data.component.html',
  styleUrls: ['./pda-section-general-data.component.css']
})
export class PdaSectionGeneralDataComponent implements OnDestroy,OnInit{

  tlfSub: Subscription;
  pctSub: Subscription;

  idFascicoloTlf : string;
  config = pdaConfiguration;
  model: PdaGeneralDataModel= null;

  isCass: boolean = false;

  constructor(private GeneralService : GeneraldataServiceTsService,private sectionService : SectionsServiceTsService,
    private dialog: DialogService, private creazionePraticaService: CreazionePraticaService, private pdaAuthService: PdaAuthService){
    // this.model = mockGeneralDataValue();
  }

  ngOnDestroy(): void {
    if(this.tlfSub) this.tlfSub.unsubscribe();
    if(this.pctSub) this.pctSub.unsubscribe();
  }

  ngOnInit(): void {
    this.getIdFascicoloTlf();
    this.getData();
    // this.model = mockGeneralDataValue();
  }

  setModel(data: any){
    this.model = data;
    PdaDataStore.getInstance().modelGeneralData = this.model;
    this.setInfos();
  }

  getIdFascicoloTlf () {
    let index = this.config.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO);
    this.idFascicoloTlf = this.config[index].properties.idFascicolo;
  }

  async updatePct() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.sectionService.updatePCT(token, this.idFascicoloTlf, "datiGenerali").subscribe(
      data => {
        this.setModel(data);
        PdaDataStore.getInstance().modelGeneralData = this.model;
        PdaDataStore.getInstance().pctInfoFascicolo = null;
        this.fetchPctFascicoloInfo(data);
      }
    )
  }

  private fetchPctFascicoloInfo(data: any) {
    if(PdaDataStore.getInstance().pctInfoFascicolo == null) {
      this.sectionService.getInfoFascicoloPct(data.idFascicoloPct).subscribe(
        fascicoloPctInfo => {
          PdaDataStore.getInstance().pctInfoFascicolo = fascicoloPctInfo;
          this.onSetPctInfoFascicolo();
        }
      );
    }
    else{
      this.onSetPctInfoFascicolo();
    }
  }

  onSetPctInfoFascicolo(){
    if(this.model != null) this.setInfos();
    let registry = pdaRegistryConst.find(reg => reg.value == PdaDataStore.getInstance().pctInfoFascicolo.registro);
    let registryType = !!registry ? registry.type : "";
    this.isCass = registryType.includes("CASS");
  }

  setInfos(){
    let fascicoloPctInfo = PdaDataStore.getInstance().pctInfoFascicolo;
    this.model.annoRuolo = fascicoloPctInfo.annoRuolo;
    this.model.numeroRuolo = fascicoloPctInfo.numeroRuolo;
    this.model.dataUltimoAggiornamento = fascicoloPctInfo.dataUltimoAggiornamento;
    this.getRegisterDescription();
  }

  async onImportDati() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.GeneralService.importDatiGenerali(
      token,
      this.idFascicoloTlf,
      this.model.sezione,
      this.model.giudice
    ).subscribe(
      data => {
        this.GeneralService.onNextImportiDati();
        this.setModel(data);
      }
    );
  }


  getData(){
    if(!PdaDataStore.isSameId(this.idFascicoloTlf)){
      PdaDataStore.cleanupStore();
      PdaDataStore.getInstance().idFascicoloTlf = this.idFascicoloTlf;
    }
    if(!!PdaDataStore.getInstance().modelGeneralData) {
      this.model = PdaDataStore.getInstance().modelGeneralData;
      this.fetchPctFascicoloInfo(this.model);
      return;
    }

    this.tlfSub = this.sectionService.getIdFascicoloPCT(this.idFascicoloTlf).subscribe({
      next : (pctInfo) =>{
        if(!!pctInfo && pctInfo.length > 0) {
          let pct = pctInfo[0];
          this.fetchPctFascicoloInfo(pct);
          this.pctSub = this.GeneralService.getGeneralData(pct.idFascicoloPct).subscribe((data)=>{
            if(!!data) {
              this.setModel(data);
              this.setInfos();
            }
          })
        }
      },error : () =>{}
    })
  }

  replaceNull (value) {
      if(value != null) return value;
      else return '';
  }

  // needRegistry(){
  //   return this.hasFascicoloPct() && PdaDataStore.getInstance().pctInfoFascicolo.registro == null;
  // }

  hasFascicoloPct(){
    return PdaDataStore.getInstance().pctInfoFascicolo != null;
  }

  openModal(){
    if(!this.hasFascicoloPct()){
      this.creazionePraticaService.createFascicoloPctWithoutRegistro(this.idFascicoloTlf).subscribe((fascicoloPctInfo) => {
        PdaDataStore.getInstance().pctInfoFascicolo = fascicoloPctInfo;
        this.openModalEditFascicoloPct();
      });
    } else{
      this.openModalEditFascicoloPct();
    }
  }

  openModalEditFascicoloPct(){
    const ref = this.dialog.open(PdaFascicolopctEditComponent, {
      data: {
        style: {
          width: '50%',
          overflow: false
        },
        title: 'Modifica Fascicolo Processo Telematico',
      }
    });
    ref.afterClosed.subscribe((event) => {
      if(!event || event.closeEvent) return;
      else if(event.modalEvent == 'submit' && event.fascicoloPct){
        this.sectionService.updateInfoFascicoloPct(event.fascicoloPct).subscribe(() => {
          this.getData();
        });
      }
    })
  }

  getRegisterDescription(){
    //!!PdaDataStore.getInstance().pdaRegisters non va
    if(PdaDataStore.getInstance().pdaRegisters == null){
      this.sectionService.getRegisters().subscribe((res) => {
        PdaDataStore.getInstance().pdaRegisters = res;
        this.setRegisterDescription();
      })
    }
    else{
      this.setRegisterDescription();
    }
  }

  setRegisterDescription(){
    let pctInfoFascicolo = PdaDataStore.getInstance().pctInfoFascicolo;
    if(!!pctInfoFascicolo.registro){
      this.model.registro = PdaDataStore.getInstance().pdaRegisters.filter(s => s.label == pctInfoFascicolo.registro)[0].descrizione;
    }
    else{
      this.model.registro = null;
    }
  }

}
